import {
  CONFIRM_LABEL_SUGGESTION,
  SET_MISSION_LABELS,
  SET_MEDIA_TOTAL,
  SET_LABELS_LOADING,
  EMPTY_LABELS_STORE,
} from '~/store/labels/mutation-types';

export default {
    [SET_LABELS_LOADING](state, loading) {
      state.loading = loading;
    },
    [SET_MISSION_LABELS](state, payload) {
      payload.forEach((label) => state.availableLabels.push({
        id: label.id,
        label: label.attributes.label,
      }));
      // sort the labels alphabetically
      // eslint-disable-next-line no-nested-ternary
      state.availableLabels = state.availableLabels.sort((a, b) => ((a.label < b.label) ? -1 : (a.label > b.label) ? 1 : 0));
    },

    [CONFIRM_LABEL_SUGGESTION](state, {
 mediaId, label, custom, suggestive, hasHero,
}) {
        // add the label to the media we will save later
      const exist = state.medias.filter((media) => media.id === mediaId).length > 0;
      if (exist) {
        if (label === null) {
          state.medias = state.medias.filter((media) => media.id !== mediaId);
        } else {
            const index = state.medias.findIndex((media) => media.id === mediaId);
            state.medias[index].label = label;
            state.medias[index].custom = custom;
            state.medias[index].suggestive = suggestive;
            state.medias[index].hasHero = hasHero;
        }
      } else {
        state.medias.push({
          id: mediaId,
          label,
          custom,
          suggestive,
          hasHero,
        });
      }
      state.customNumber = state.medias.filter((media) => media.custom).length;
      state.canSubmitLabels = state.medias.filter((media) => media.label != null && media.label !== '').length === state?.total;
    },

    [SET_MEDIA_TOTAL](state, total) {
        state.total = total;
    },

    [EMPTY_LABELS_STORE](state) {
      state.loading = false;
      state.labels = [];
      state.availableLabels = [];
      state.medias = [];
      state.error = {};
      state.customNumber = 0;
      state.canSubmitLabels = false;
      state.tooMuchCustom = false;
      state.total = 0;
    },
};
